import { ILandingData } from "../../../common/context/landingTitle/types";
import { replaceText } from "../../../common/helpers/textReplacer";
import { IEntityFilter, IFilter } from "../../context/filters";
import { ISelectedFilterMap } from "../../context/selectedFilters";
import { MAX_FILTERS } from "./constants";

const sortEntityFilters = (
  { featured: featuredA, level: levelA }: IEntityFilter,
  { featured: featuredB, level: levelB }: IEntityFilter
): number => {
  const haveSameFeatured = featuredA === featuredB;
  if (!haveSameFeatured) {
    return featuredB ? 1 : -1;
  }
  return levelA - levelB;
};

export const getFilterText = (
  entityFilter: IEntityFilter,
  filter: IFilter,
  prepositionText: string
) => {
  const entityPart = entityFilter.withEntity ? entityFilter.entity.label : "";
  const prepositionPart = entityFilter.withPreposition ? prepositionText : "";
  const filterLabel = filter.label;
  return [entityPart, prepositionPart, filterLabel].filter(part => part.length > 0).join(" ");
};

export const getFiltersText = ({ featured, secondary }: ISelectedFilterMap, language: string) => {
  const filterMap = { ...featured, ...secondary };
  const entityFilters = Object.keys(filterMap)
    .map(key => filterMap[key].entityFilter)
    .sort(sortEntityFilters)
    .slice(0, MAX_FILTERS);

  const text = entityFilters
    .map(entityFilter =>
      getFilterText(entityFilter, filterMap[entityFilter.entity.slug].filter, language)
    )
    .join(" ");

  return ` ${text}`;
};

export const generateTitle = (
  data: ILandingData,
  selectedFilterMap: ISelectedFilterMap,
  prepositionText: string
) => {
  const selectedFiltersExists =
    Object.keys({ ...selectedFilterMap.featured, ...selectedFilterMap.secondary }).length > 0;
  const filterText: string = selectedFiltersExists
    ? getFiltersText(selectedFilterMap, prepositionText)
    : "";
  return {
    description: replaceText(data.description, { filterText }),
    metaDescription: replaceText(data.metaDescription, { filterText }),
    metaTitle: replaceText(data.metaTitle, { filterText }),
    title: replaceText(data.title, { filterText }),
    ...(data.heroDescription ? { heroDescription: data.heroDescription } : {}),
    noIndex: Boolean(data.noIndex)
  };
};
